@let header = headerStore()!;
@let headerSubMenu = headerSubMenuStore()!;
@let isMobile = breakpoints() === "mobile";
<app-promotion (click)="this.isMenuOpen.set(false)" />
@if (!!header) {
  <header>
    @if (header | isHeaderDefault) {
      <div class="relative z-50 h-[50px] bg-anis">
        <div class="centered-with-padding flex h-full items-center justify-between">
          <div class="z-50 flex h-full items-center gap-x-10">
            <button (click)="toggleMenu()" class="cursor-pointer select-none">
              <div class="group flex h-[17px] w-[21px] flex-col justify-between">
                <span
                  [ngClass]="{
                    'group-hover:rotate-[5deg]': !isMenuOpen(),
                    'translate-y-[7px] -rotate-45': isMenuOpen(),
                  }"
                  class="h-[3px] w-[21px] rounded-sm bg-verdigris transition-transform"></span>
                <span
                  [ngClass]="{
                    'group-hover:rotate-[-5deg]': !isMenuOpen(),
                    'rotate-45': isMenuOpen(),
                  }"
                  class="h-[3px] w-[21px] rounded-sm bg-verdigris transition-transform"></span>
                <span
                  [ngClass]="{
                    'group-hover:rotate-[5deg]': !isMenuOpen(),
                    'translate-y-[-7px] rotate-45': isMenuOpen(),
                  }"
                  class="h-[3px] w-[21px] rounded-sm bg-verdigris transition-transform"></span>
              </div>
            </button>
            @let homeLink = header.homeLink;
            <a
              (click)="isMenuOpen.set(false)"
              [routerLink]="homeLink.url || baseUrl()"
              class="flex cursor-pointer transition hover:scale-110">
              <app-svg [inline]="true" [src]="homeLink.svg" [width]="117" />
            </a>
          </div>
          <div class="z-50 mt-8 flex gap-x-1.5 desk:mt-10 desk:gap-x-3">
            @let width = isMobile ? 59 : 65;
            @let height = isMobile ? 70 : 77;
            @for (picto of header.items.pictos; track picto.url) {
              <a
                (click)="isMenuOpen.set(false)"
                [routerLink]="picto.url"
                [style.height.px]="height"
                [style.width.px]="width"
                class="group relative cursor-pointer">
                <div
                  [style.height.px]="height"
                  [style.width.px]="width"
                  class="btn-ripple-max mask-btn-menu absolute z-10 bg-white group-active:translate-x-0.5 group-active:translate-y-0.5">
                  <div class="absolute z-20">
                    @if ("svg" in picto) {
                      <app-svg [height]="height" [inline]="true" [src]="picto.svg" [width]="width" />
                    } @else if ("image" in picto) {
                      <app-image
                        [image]="picto.image"
                        [isLoading]="false"
                        [isPriority]="true"
                        [size]="{ mw: 59, mh: 70, dw: 65, dh: 77 }" />
                    }
                  </div>
                </div>
                <app-svg
                  [height]="height"
                  [isPriority]="true"
                  [width]="width"
                  class="drop-shadow-custom absolute group-active:translate-x-0.5 group-active:translate-y-0.5 group-active:drop-shadow-none"
                  src="assets/svgs/bg-menu-icon.svg" />
              </a>
            }
          </div>
        </div>
      </div>
      @defer {
        <div class="relative left-0 top-0 z-30" id="menu">
          <app-menu [(isMenuOpen)]="isMenuOpen" [menu]="header.menu" />
        </div>
      }
      @if (headerSubMenu; as menuBlog) {
        <app-menu-blog [menuBlog]="menuBlog.menu" />
      }
    }
    @if (header | isHeaderTunnel) {
      @let hasStepLinks = header.hasSteps;
      @let hasStepBudgetEstimator = isBudgetEstimatorPage();
      <div
        [class.h-[63px]]="!hasStepLinks && !hasStepBudgetEstimator"
        [class.h-[88px]]="hasStepLinks || hasStepBudgetEstimator"
        class="mask-curve-bottom relative z-50 bg-anis desk:mb-0 desk:h-[50px] desk:[mask:none]">
        <div
          class="desk:centered-with-padding grid grid-cols-[auto_36px] items-center desk:grid-cols-[250px_1fr_250px]">
          <div
            [ngClass]="{
              'pt-1 h-[50px] desk:col-span-2': !hasStepLinks && !hasStepBudgetEstimator,
              'pt-2': hasStepLinks || hasStepBudgetEstimator,
            }"
            class="flex items-center justify-center pb-1 pl-[36px] desk:order-1 desk:h-[50px] desk:justify-start desk:pl-[54px] desk:pt-1">
            <a
              [ngClass]="{
                'h-[27px] w-[117px]': !hasStepLinks && !hasStepBudgetEstimator,
                'h-[21px] w-[89px]': hasStepLinks || hasStepBudgetEstimator,
              }"
              [routerLink]="['']"
              class="over:scale-110 block cursor-pointer transition desk:h-[27px] desk:w-[117px]">
              <app-svg [height]="28" [inline]="true" [width]="117" src="assets/logos/svg/logo_socooc.svg" />
            </a>
          </div>
          <a [routerLink]="['']" class="flex items-center justify-center desk:order-3 desk:justify-self-end">
            <app-svg [width]="16" class="cursor-pointer" src="assets/icons/close.svg" />
          </a>
          @if (hasStepLinks) {
            <div
              class="col-span-2 grid w-[400px] grid-cols-3 justify-items-center gap-x-2.5 justify-self-center px-10 desk:order-2 desk:col-span-1 desk:h-[50px]">
              <a
                (click)="onStepClick(1)"
                [ngClass]="{ 'opacity-40 cursor-pointer': funnelStep() !== 1, 'pointer-events-none': funnelStep() < 1 }"
                class="flex w-fit flex-col items-center justify-center pb-0.5 leading-none">
                <span class="font-title text-[30px]">1</span>
                <span class="text-[10px] font-bold">{{ "COMPONENT.MENU-TUNNEL.STORE" | translate }}</span>
              </a>
              <a
                (click)="onStepClick(2)"
                [ngClass]="{ 'opacity-40 cursor-pointer': funnelStep() !== 2, 'pointer-events-none': funnelStep() < 2 }"
                class="flex w-fit flex-col items-center justify-center pb-0.5 leading-none">
                <span class="font-title text-[30px]">2</span>
                <span class="text-[10px] font-bold">{{ "COMPONENT.MENU-TUNNEL.DAY_AND_TIME" | translate }}</span>
              </a>
              <div
                [ngClass]="{ 'opacity-40 cursor-pointer': funnelStep() !== 3, 'pointer-events-none': funnelStep() < 3 }"
                class="flex w-fit flex-col items-center justify-center pb-0.5 leading-none">
                <span class="font-title text-[30px]">3</span>
                <span class="text-[10px] font-bold">{{ "COMPONENT.MENU-TUNNEL.CONTACT_DETAILS" | translate }}</span>
              </div>
            </div>
          }
          @if (hasStepBudgetEstimator && budgetEstimatorCurrentStep()) {
            <div
              class="col-span-2 grid grid-cols-4 justify-items-center gap-x-2.5 px-10 desk:order-2 desk:col-span-1 desk:h-[50px] desk:gap-x-2 desk:pt-1.5">
              <div [class.opacity-40]="budgetEstimatorCurrentStep() !== 1" class="flex flex-col">
                <span class="flex h-full items-end justify-center pt-1 font-title text-[30px] desk:pt-0"> 1 </span>
                <span class="flex h-full pt-2 text-center text-[10px] font-bold leading-none">
                  {{ "COMPONENT.ESTIMATEUR-ETAPE.HEADER.FURNITURE_LABEL" | translate }}
                </span>
              </div>
              <div [class.opacity-40]="budgetEstimatorCurrentStep() !== 2" class="flex flex-col">
                <span class="flex h-full items-end justify-center pt-1 font-title text-[30px] desk:pt-0"> 2 </span>
                <span class="flex h-full pt-2 text-center text-[10px] font-bold leading-none">
                  {{ "COMPONENT.ESTIMATEUR-ETAPE.HEADER.APPLIANCES_AND_PLUMBING_LABEL" | translate }}
                </span>
              </div>
              <div [class.opacity-40]="budgetEstimatorCurrentStep() !== 3" class="flex flex-col">
                <span class="flex h-full items-end justify-center pt-1 font-title text-[30px] desk:pt-0"> 3 </span>
                <span class="flex h-full pt-2 text-center text-[10px] font-bold leading-none">
                  {{ "COMPONENT.ESTIMATEUR-ETAPE.HEADER.DELIVERY_AND_INSTALLATION_LABEL" | translate }}
                </span>
              </div>
              <div [class.opacity-40]="budgetEstimatorCurrentStep() !== 4" class="flex flex-col">
                <span class="flex h-full items-end justify-center pt-1 font-title text-[30px] desk:pt-0"> 4 </span>
                <span class="flex h-full pt-2 text-center text-[10px] font-bold leading-none">
                  {{ "COMPONENT.ESTIMATEUR-ETAPE.HEADER.PRICE_ESTIMATE_LABEL" | translate }}
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </header>
}
